import { Reactive, ReactRouterConfig } from '@scfe-common/micro-frontend-utils';

import { $gt } from '@/common/appCtx';
import WorkstationDashboard from '@/pages/workstation-dashboard';
import TvMode from '@/pages/workstation-dashboard/tv-mode';

const config = (): ReactRouterConfig => {
  return {
    path: '/workstation-dashboard',
    component: () => Reactive,
    redirect: '/workforceops/workstation-dashboard/overview',
    children: [
      {
        path: 'overview',
        component: () => WorkstationDashboard,
      },
      {
        path: 'tv-mode',
        component: () => TvMode,
        meta: {
          title: $gt('TV Mode'),
        },
      },
    ],
  };
};
export default config;
